<footer class="fl-row">
    <div class="ft-col">
        <p>{{ 'footer.Copyright' | translate }}, {{ 'footer.AppliedParticleTechnology' | translate }}. {{ 'footer.AllRightsReserved' | translate }}.</p>
    </div>
    <div class="ft-col">
        <p>{{ 'footer.LocalTime' | translate }}</p>
    </div>
</footer>
